import React, { useCallback, useEffect, useState } from "react";
import "../../App.css";

import TelegramText from "../../components/kit/Text/TelegramText";
import { useTelegram } from "../../hooks/useTelegram";
import TelegramScreen from "../../components/kit/Screen/TelegramScreen";
import TelegramHeader from "../../components/kit/Header/TelegramHeader";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { PATH_ORDER_MANAGEMENT } from "../../constants/Paths";
import { updateCurrentTimeSlotOrders, replaceCart } from "../../components/kit/Redux/Actions";
import { getStoreSpecificOrders } from "../../db/db";

const ThankYouScreen = () => {
  const { webApp, executeMethod } = useTelegram();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const sessionToken = useSelector((state) => state.sessionToken);
  const userProfile = useSelector((state) => state.userProfile);
  const selectedStore = useSelector((state) => state.selectedStore);

  const [continueOrderingEnabled, setContinueOrderingEnabled] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false);

  useEffect(() => {
    try {
      const config = localStorage.getItem('continueOrderingConfig');
      if (config) {
        const parsed = JSON.parse(config);
        setContinueOrderingEnabled(parsed.enabled === true);
      }
    } catch (error) {
      // ignore
    }
  }, []);

  const onMainClick = useCallback(() => {
    executeMethod("close", webApp.close, true);
  }, [executeMethod]);

  const onBackClick = useCallback(() => {
    executeMethod("close", webApp.close, true);
  }, [executeMethod]);

  const onContinueOrdering = useCallback(async () => {
    try {
      setIsNavigating(true);

      // Clear cart for new order
      dispatch(replaceCart([]));

      // Reload orders for the current store
      if (sessionToken && userProfile?.userid && selectedStore?.storeId) {
        const storeOrders = await getStoreSpecificOrders(
          sessionToken,
          selectedStore.storeId,
          userProfile.userid
        );
        if (storeOrders) {
          dispatch(updateCurrentTimeSlotOrders(storeOrders));
        }
      }

      navigate(PATH_ORDER_MANAGEMENT, { replace: true });
    } catch (error) {
      console.error("[ThankYou] Error loading orders:", error);
      navigate(PATH_ORDER_MANAGEMENT, { replace: true });
    }
  }, [navigate, dispatch, sessionToken, userProfile, selectedStore]);

  useEffect(() => {
    webApp.ready();
    webApp.disableClosingConfirmation();
    webApp.MainButton.hideProgress(true);
    webApp.MainButton.enable();

    webApp.MainButton.onClick(onMainClick);
    webApp.BackButton.onClick(onBackClick);

    webApp.MainButton.text = "THANK YOU";
    webApp.MainButton.color = "#31b545";

    webApp.MainButton.show();
    webApp.BackButton.hide();

    if (!webApp.isExpanded) {
      executeMethod("expand", webApp.expand, true);
    }
    return () => {
      webApp.MainButton.offClick(onMainClick);
      webApp.BackButton.offClick(onBackClick);
    };
  }, [webApp, onMainClick, onBackClick]);

  return (
    <TelegramScreen showbackbutton={0} className={"parent-container"}>
      <TelegramHeader>
        <TelegramText className={"header-text"}>
          Thank you for your order
        </TelegramText>
      </TelegramHeader>
      <TelegramText className={`centered-text big-text`}>
        Do prepare cash, only cash accepted
      </TelegramText>
      <TelegramText className={`centered-text big-text`}>
        Driver will contact 10-15mins before arrival
      </TelegramText>
      {continueOrderingEnabled && (
        <div style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "30px",
          padding: "0 24px",
        }}>
          <button
            onClick={onContinueOrdering}
            disabled={isNavigating}
            style={{
              padding: "14px 24px",
              fontSize: "16px",
              fontWeight: "600",
              color: "#fff",
              backgroundColor: isNavigating ? "#93c5fd" : "#3b82f6",
              border: "none",
              borderRadius: "10px",
              cursor: isNavigating ? "default" : "pointer",
              width: "100%",
              maxWidth: "320px",
              opacity: isNavigating ? 0.7 : 1,
            }}
          >
            {isNavigating ? "Loading..." : "Continue Ordering"}
          </button>
        </div>
      )}
    </TelegramScreen>
  );
};

export default ThankYouScreen;
